import script from "./UnpublishButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnpublishButton.vue?vue&type=script&lang=ts&setup=true"

import "./UnpublishButton.vue?vue&type=style&index=0&id=4a2d3fca&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/r1/a/_Build/release/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a2d3fca"]])

export default __exports__